<template>
  <section>
    <b-collapse class="card" aria-id="contentIdForA11y3" :open="false" @open="open = true">
      <div
        slot="trigger"
        slot-scope="props"
        class="card-header"
        role="button"
        aria-controls="contentIdForA11y3"
      >
        <p class="card-header-title" >{{rank}}位:{{title}}</p>
        <p class="card-header-icon">
          <a class="button is-info" @click="cardModal" style="margin-right: 12px;">対戦</a>
        </p>
      </div>
    </b-collapse>
  </section>
</template>
<script>

const apiUrl = process.env.VUE_APP_DB_API


import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/python/python.js";
import "codemirror/theme/mbo.css";
import "codemirror/addon/selection/active-line.js";
import "codemirror/addon/edit/closebrackets.js";

import Battle from "./Battle"

export default {
  data() {
    return {
      open: false,
      cmOptions: {
        autoCloseBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        line: true,
        mode: "text/x-python",
        readOnly: "true"
      }
    };
  },
  components: {
    codemirror,
    Battle
  },
  computed:{
    user_code(){
      return this.$store.state.user_code
    },
    jankenHistory: {
      get() {
        return this.$store.state.jankenHistory
      },
      set(h) {
        this.$store.commit("setJankenHistory", h);
      }
    },
    enemy_id: {
      get() {
        return this.$store.state.enemy_id
      },
      set(id) {
        this.$store.commit("setEnemyId", id);
      }
    },
    enemy_title:{
      get(){
        return this.$store.state.enemy_title
      },
      set(title){
        this.$store.commit("setEnemyTitle",title)
      }
    }
  },
  props: ["id", "title", "code","rank"],
  methods: {
    cardModal() {
      this.enemy_id = this.id
      this.enemy_title = this.title

      this.$buefy.modal.open({
        parent: this,
        component: Battle,
        hasModalCard: true,
        customClass: "custom-class custom-class-2",
      });
    },
  }
};
</script>
<style scoped>
.card-footer {
  background-color: #209cee;
  color: #ffffff;
  font-size: 18px;
}

</style>>